<template lang="pug">
    .eventCard(:style="{backgroundImage: 'url('+event.PREVIEW_PICTURE+')'}" :class="[event.PREVIEW_GRADIENT]")
        .eventCardWrapper
            .date {{event.DATE}}
            div
                h3(v-html="event.NAME")
                .text(v-html="event.PREVIEW_TEXT")
            .bottom
                router-link(tag="h6" :to="'/allevents?tag='+event.EVENT_TAG") {{event.EVENT_STATUS}} - {{event.EVENT_TAG}}
                .app_btn.white_fill(v-if="event.SUBSCR_AVAILABLE && event.USER_SUBSCRIBED === 'N'"
                    @click.stop.prevent="$store.commit('openPopup', 'Subscribe'), $store.commit('setPopupContent', {type: 'event', code: event.CODE, name: event.NAME})") {{$t('other.subscribe')}}
                .app_btn.light_blue(v-if="event.USER_SUBSCRIBED === 'Y'") {{$t('other.youAreSubscribed')}}
</template>

<script>
    export default {
        name: "EventCard",
        props: {
            event: {
                require: true,
            }
        },
    }
</script>

<style scoped lang="scss">

    .eventCard {
        height: 100%;
        border-radius: 1rem;
        color: #fff;
        background: no-repeat center center / cover #000;
        cursor: pointer;
        overflow: hidden;

        &.black .eventCardWrapper {
            background: linear-gradient(to right, #000 40%, $dark_gray 70%);

            .date {
                text-shadow: 0 0 1rem #000;
            }
        }

        &.red .eventCardWrapper {
            background: linear-gradient(to right, $red 40%, $blue2 70%);

            .date {
                text-shadow: 0 0 1rem $red;
            }
        }

        &.blue .eventCardWrapper {
            background: linear-gradient(to right, $blue 40%, $blue1 70%);

            .date {
                text-shadow: 0 0 1rem $blue;
            }
        }
    }

    .eventCardWrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        padding: 1.8rem 1.8rem 1.3rem;
        border-radius: inherit;
    }

    .date {
        position: absolute;
        top: 2rem;
        right: 2rem;
        font-size: 2.5rem;
        text-shadow: 0 0 1rem #000;
    }

    h3 {
        max-width: 84%;
        margin-bottom: 0.85rem;
        font-size: 2.5rem;
        line-height: 1.2;
        text-shadow: 0 0 1.5rem rgba(#fff, 0.5);
    }

    .text {
        font-family: Arial;
        font-size: to_rem(15px);
        line-height: 1.2;
        letter-spacing: -0.005rem;

        &::v-deep p {
            -ms-text-overflow: ellipsis;
            text-overflow: ellipsis;
            overflow: hidden;
            -ms-line-clamp: 16;
            -webkit-line-clamp: 14;
            line-clamp: 16;
            display: -webkit-box;
            display: box;
            word-wrap: break-word;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            height: auto;
            max-width: 65%;
            margin-bottom: 1.1rem;
        }
    }

    h6 {
        margin-right: 1.5rem;
        font-size: 1.25rem;
        transition: text-shadow .2s;
        &:hover{
            text-shadow: 0 0 1.5rem rgba(#000, 1);
        }
    }

    .app_btn {
        padding: 0.4rem 1.2rem 0.35rem;
    }

    .bottom {
        display: flex;
        align-items: center;
    }

    @include mobile_or_P {
        .eventCardWrapper {
            padding: 1.25rem 1.4rem 1rem;
        }
        .date {
            top: auto;
            right: 1rem;
            bottom: 0.8rem;
            font-size: 1.5rem;
        }
        h3 {
            max-width: 100%;
            margin-bottom: 0.3rem;
            font-size: 1.9rem;
        }
        .text {
            margin-bottom: 1rem;
            font-size: 1.045rem;

            &::v-deep p {
                max-width: 100%;
            }
        }
        h6 {
            margin-right: 1.2rem;
            font-size: 0.92rem;
        }
        .app_btn {
            padding: 0.3rem 1rem 0.3rem;
            font-size: 0.9rem;
        }
        .bottom {
            margin-top: 0.5rem;
            padding-left: 0.2rem;
        }
    }
</style>
